import React from "react"
import { Box } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { ButtonNova } from "@nutrafol/nutrafol-ui-kit/dist/ButtonNova"
import Bullet from "../../../../../assets/icons/nova/bullet-orange.svg"
import { BenefitsWrapper, BenefitsItem, Benefit } from "./benefits.styled"

const Benefits = ({
  items = [],
  labels = [],
  containerClasses = null,
  handleViewLabel = null,
}) => {
  const buildAnswers = (answer, useBullet) => {
    return answer.map((line, i) => (
      <BenefitsItem width={1} key={i}>
        {useBullet ? (
          <Box>
            <Bullet />
          </Box>
        ) : null}
        <Box>
          <TextElementNova text={line} className="Body-20-Dia-Normal" />
        </Box>
      </BenefitsItem>
    ))
  }

  return (
    <BenefitsWrapper className={containerClasses || null}>
      {items.map((item, i) =>
        item.title ? (
          <Benefit key={i} className="benefit">
            <Box width={1}>
              <TextElementNova
                element="p"
                text={item.title}
                className={`Body-20-Dia-Strong ${
                  item.answer.length > 0 ? "pb-2 md:pb-4" : ""
                }`}
              />
            </Box>
            {buildAnswers(
              item?.answer,
              item?.title.toLowerCase() !== "recommended usage"
            )}
            {item.title2 ? (
              <>
                <Box width={1} mt={[8, 8, 8, 16]}>
                  <TextElementNova
                    element="p"
                    text={item.title2}
                    className="Body-20-Dia-Strong benefit-heading-two pb-2 md:pb-4"
                  />
                </Box>
                {buildAnswers(
                  item?.answer2,
                  item?.title.toLowerCase() !== "recommended usage"
                )}
              </>
            ) : null}

            {handleViewLabel ? (
              <>
                {labels[i] && (
                  <Box pt={[8, null, null, 16]}>
                    <ButtonNova
                      label={labels[i]}
                      level={"Textlink"}
                      onClick={() => handleViewLabel(i)}
                    />
                  </Box>
                )}
              </>
            ) : null}
          </Benefit>
        ) : null
      )}
    </BenefitsWrapper>
  )
}
export default Benefits
